"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tiers = [{
  nombre: "Grow",
  descripcion: "Para PyMEs ordenando operaciones. Foco en una o dos áreas core a la vez. Ritmo semanal, reuniones quincenales.",
  caracteristicas: ["Una o dos áreas core activas en paralelo.", "Avances semanales como activos entregados — no reportes de horas.", "Reuniones quincenales con el equipo de cliente."],
  cuandoAplica: "Útil cuando el negocio está aterrizando un primer frente técnico serio y quiere ritmo sostenido sin sobrecarga de gobernanza."
}, {
  nombre: "Build",
  descripcion: "Para PyMEs escalando con múltiples frentes técnicos en paralelo. Acceso directo a Fractional CTO para decisiones estratégicas.",
  caracteristicas: ["Hasta cuatro áreas core en paralelo.", "Acceso a Fractional CTO para decisiones de arquitectura, vendor selection, contratación de equipo técnico interno cuando aplique.", "Reuniones semanales con el equipo de cliente."],
  cuandoAplica: "Útil cuando el negocio ya validó que la tecnología es palanca y necesita atacar varios frentes simultáneamente con criterio estratégico."
}];
export default function DosTiersPartner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="partner-tiers" id="dos-tiers" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-5xl">
        <div ref={ref} className={`mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-6">
            Dos tiers según volumen.
          </h2>

          <p className="font-sans text-lg text-muted-foreground leading-relaxed max-w-2xl">
            Misma metodología, distinta intensidad. El tier correcto depende de cuántos frentes técnicos estén abiertos al mismo tiempo y qué nivel de acceso estratégico necesita el negocio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {tiers.map((tier, i) => <TierBloque key={tier.nombre} tier={tier} index={i} />)}
        </div>
      </div>
    </section>;
}
function TierBloque({
  tier,
  index
}: {
  tier: {
    nombre: string;
    descripcion: string;
    caracteristicas: string[];
    cuandoAplica: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`bg-card border border-border rounded-sm p-8 md:p-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="font-mono text-xs tracking-widest text-primary uppercase mb-4">
        Tier · {tier.nombre}
      </div>

      <h3 className="font-serif text-4xl md:text-5xl font-normal text-foreground leading-tight mb-6">
        {tier.nombre}
      </h3>

      <p className="font-sans text-base md:text-lg text-foreground/90 leading-relaxed mb-8">
        {tier.descripcion}
      </p>

      <ul className="space-y-4 mb-8">
        {tier.caracteristicas.map((item, i) => <li key={i} className="flex gap-3 font-sans text-sm md:text-base text-muted-foreground leading-relaxed">
            <span className="font-mono text-primary text-xs mt-1.5 shrink-0">
              ·
            </span>
            <span>{item}</span>
          </li>)}
      </ul>

      <p className="font-sans text-sm md:text-base italic text-muted-foreground/90 leading-relaxed border-t border-border/30 pt-6">
        {tier.cuandoAplica}
      </p>
    </div>;
}